import React from 'react';

const SOURCE_LABELS: Record<string, string> = {
  email: 'Email',
  form: 'Form',
  sr: 'SR',
};

const SOURCE_STYLES: Record<string, { background: string; color: string }> = {
  email: { background: '#e0f2fe', color: '#0369a1' },
  form: { background: '#f3e8ff', color: '#7c3aed' },
  sr: { background: '#dcfce7', color: '#15803d' },
};

interface SourceBadgeProps {
  source?: string | null;
}

export const SourceBadge: React.FC<SourceBadgeProps> = ({ source }) => {
  const key = (source || 'email').toLowerCase();
  const label = SOURCE_LABELS[key] || key.toUpperCase();
  const style = SOURCE_STYLES[key] || SOURCE_STYLES.email;

  return (
    <span
      className="source-badge"
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: '999px',
        fontSize: '0.75rem',
        fontWeight: 600,
        letterSpacing: '0.02em',
        background: style.background,
        color: style.color,
      }}
    >
      {label}
    </span>
  );
};
